<button
  mat-raised-button
  class="color--{{color}}"
  [disabled]="disabled"
  [color]="color || 'primary'"
  [matTooltip]="tooltip">
  <ng-content></ng-content>
</button>
